import { defineMessages } from 'react-intl';

export const locale = defineMessages({
  htmlTitle: {
    id: 'add-ons.pageTitle',
    description: 'Title to the page',
    defaultMessage: 'Create an add-on'
  },
  createPageTitle: {
    id: 'add-ons.createPageTitle',
    description: 'Title to the create page',
    defaultMessage: 'Create an add-on'
  },
  editPageTitle: {
    id: 'add-ons.editPageTitle',
    description: 'Title to the edit page',
    defaultMessage: 'Edit your add-on'
  },
  description: {
    id: 'add-ons.description',
    description: 'Information about add-ons',
    defaultMessage:
      'Offer additional items to your ticket buyers during checkout that can be picked up or redeemed at your event.'
  },
  backToInventory: {
    id: 'add-ons.backToInventory',
    description: 'Go back to the inventory view',
    defaultMessage: 'Back to inventory'
  }
});
